import(/* webpackMode: "eager", webpackExports: ["RouteProviders"] */ "/vercel/path0/src/app/route-providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WordGameFontPreloads"] */ "/vercel/path0/src/app/word-game-font-preloads.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/styles/poppins.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/styles/globals.css");
